import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

export const MusicVideo = forwardRef(({ videoId, title }, ref) => {
  const frame = useRef(null);
  const [muted, setMuted] = useState(true);

  const cmd = (func) =>
    frame.current?.contentWindow?.postMessage(JSON.stringify({ event: "command", func, args: [] }), "*");

  const setSound = (on) => {
    cmd(on ? "unMute" : "mute");
    if (on) cmd("playVideo");
    setMuted(!on);
  };

  useImperativeHandle(ref, () => ({ mute: () => setSound(false) }));

  const src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&playsinline=1&rel=0&modestbranding=1&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`;
  return (
    <section className="relative" data-testid="music-video-section">
      <div className="font-mono text-[10px] tracking-[0.3em] text-white/50 mb-4">/ OFFICIAL MUSIC VIDEO</div>
      <div className="relative aspect-video w-full overflow-hidden rounded-2xl border border-white/10 shadow-[0_40px_120px_rgba(0,0,0,0.55)] bg-black">
        <iframe ref={frame} title={title} src={src} className="absolute inset-0 w-full h-full" frameBorder="0" referrerPolicy="strict-origin-when-cross-origin"
                allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen data-testid="music-video-iframe" />
        <button onClick={() => setSound(muted)}
                className="absolute bottom-4 left-4 z-10 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-black/60 backdrop-blur-md border border-white/20 text-xs font-bold tracking-[0.15em] transition-colors duration-200 hover:bg-black/80"
                data-testid="music-video-sound-btn">
          {muted ? <VolumeX size={14} /> : <Volume2 size={14} />}
          {muted ? "TAP FOR SOUND" : "MUTE"}
        </button>
      </div>
    </section>
  );
});
MusicVideo.displayName = "MusicVideo";
